import React, { Component } from 'react';
import {
  maskEmail,
  MAGIC_LINK_LIFETIME_MINUTES,
  MAGIC_LINK_RESEND_SECONDS,
} from 'utils/magicLink';
import './SignIn.scss';

export const MAIL_APPS = [
  { name: 'Gmail', href: 'https://mail.google.com/' },
  { name: 'Outlook', href: 'https://outlook.live.com/' },
];

// "Check your email" after a sign-in link was sent. Used by the sign-in panel and by
// /MagicLogin after "Email me a new link".
//
// Resend stays disabled for `cooldownSeconds` (30 by default, or the Retry-After of a
// 429). Changing `cooldownKey` restarts the countdown.
export class CheckEmail extends Component {
  static defaultProps = {
    cooldownSeconds: MAGIC_LINK_RESEND_SECONDS,
    cooldownKey: 0,
  };

  state = { remaining: 0 };

  componentDidMount() {
    this.startCountdown(this.props.cooldownSeconds);
    if (this.props.autoFocus && this.heading) {
      this.heading.focus();
    }
  }

  componentDidUpdate(previousProps) {
    if (previousProps.cooldownKey !== this.props.cooldownKey) {
      this.startCountdown(this.props.cooldownSeconds);
    }
  }

  componentWillUnmount() {
    this.stopCountdown();
  }

  startCountdown(seconds) {
    this.stopCountdown();
    const remaining = Math.max(0, Math.ceil(Number(seconds) || 0));
    this.setState({ remaining });
    if (remaining > 0) {
      this.timer = setInterval(this.tick, 1000);
    }
  }

  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  tick = () => {
    const remaining = Math.max(0, this.state.remaining - 1);
    this.setState({ remaining });
    if (remaining === 0) {
      this.stopCountdown();
    }
  };

  handleResend = event => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (this.state.remaining > 0 || this.props.resending) {
      return undefined;
    }
    return this.props.onResend && this.props.onResend();
  };

  resendLabel() {
    if (this.props.resending) {
      return 'Sending…';
    }
    if (this.state.remaining > 0) {
      return `Resend link in ${this.state.remaining}s`;
    }
    return 'Resend link';
  }

  render() {
    const { email, message, messageIsError, onUsePassword, resending } = this.props;
    const waiting = this.state.remaining > 0;
    return (
      <div className="sign-in-check">
        <div className="sign-in-check__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="40" height="40">
            <path
              fill="currentColor"
              d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4-8 5-8-5V6l8 5 8-5z"
            />
          </svg>
        </div>
        <h2
          id={this.props.titleId || 'sign-in-title'}
          className="sign-in__title"
          tabIndex={-1}
          ref={node => {
            this.heading = node;
          }}
        >
          Check your email
        </h2>
        <p className="sign-in-check__sent">
          We sent a sign-in link to <strong>{maskEmail(email)}</strong>
        </p>
        <ul className="sign-in-check__help">
          <li>Tap the link in the email to sign in. It works once.</li>
          <li>It expires in {MAGIC_LINK_LIFETIME_MINUTES} minutes.</li>
          <li>Can’t see it? Check your spam or junk folder.</li>
        </ul>
        <div className="sign-in-check__apps">
          {MAIL_APPS.map(app => (
            <a
              key={app.name}
              className="sign-in-btn sign-in-btn--outline sign-in-check__app"
              href={app.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open {app.name}
              <span className="sign-in-visually-hidden"> (opens in a new tab)</span>
            </a>
          ))}
        </div>
        <button
          type="button"
          className="sign-in-btn sign-in-btn--secondary sign-in-check__resend"
          onClick={this.handleResend}
          disabled={waiting || !!resending}
          aria-disabled={waiting || !!resending}
        >
          {this.resendLabel()}
        </button>
        {message && (
          <p
            className={
              messageIsError ? 'sign-in__message sign-in__message--error' : 'sign-in__message'
            }
            role={messageIsError ? 'alert' : 'status'}
          >
            {message}
          </p>
        )}
        {onUsePassword && (
          <button type="button" className="sign-in-link sign-in-check__password" onClick={onUsePassword}>
            Use my password instead
          </button>
        )}
      </div>
    );
  }
}

export default CheckEmail;



// WEBPACK FOOTER //
// ./src/components/SignIn/CheckEmail.js